export default __webpack_public_path__ + "static/media/banner-dashboard.df95ca7c.svg";